import NextError from "next/error";

const statusCodes = {
  400: "Bad Request",
  404: "Page introuvable",
  405: "Method Not Allowed",
  500: "Internal Server Error",
};

const CustomError = ({ statusCode }) => {
  const title = statusCodes[statusCode] || "Oups, une erreur est survenue";

  return <NextError title={title} statusCode={statusCode || "¯\\_(ツ)_/¯"} />;
};

export default CustomError;
